<button matTooltip="{{authService?.user?.email}}" class="user_menu_button" mat-icon-button [mat-menu-trigger-for]="menu">
  <mat-icon class="user_menu_icon">person</mat-icon>
</button>
<mat-menu class="user_menu" #menu="matMenu">
  <span class="user_menu_headline">{{authService?.user?.email}}</span>
  <button (click)="authService.signOut()" class="user_menu_item_button" mat-menu-item>
    <mat-icon class="user_menu_item_icon logout">logout</mat-icon>
    <span class="user_menu_item_text">Abmelden</span>
  </button>
</mat-menu>
